<div ng-controller="TranscriptConfigController as transcriptConfigEditCtrl" class="modal-view ">
    <c-auto-form config="transcriptConfigEditCtrl.autoformConfig"></c-auto-form>
</div>